import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../store/slices/authSlice';
import Logo from '../components/LogoHeader'
import ProfileIcon from '../components/icons/ProfileIcon'
import SearchIcon from '../components/icons/SearchIcon'
import SettingsIcon from '../components/icons/SettingsIcon'
import CloseIcon from '../components/icons/CloseIcon'
import InfoIcon from '../components/icons/InfoIcon'
import EmailIcon from '../components/icons/EmailIcon'


const Header = () => {

    const [open, setOpen] = useState(false)

    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.auth.isLoading);

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    return (
        <>
            <header className="w-full px-5 h-[60px] flex fixed justify-between items-center border-b border-custom-charcoal bg-custom-dark z-[1000]">
            <div className='inline-block'>
                <Logo />
            </div>
            <div className="flex gap-3 sm:gap-5 items-center">
                {/* <div className=''>
                    <SearchIcon />
                </div> */}

                <Link to="mailto:info@oreca.pro?subject=Enquiry from Oreca Pro Website" className='inline-block'>
                    <EmailIcon />
                </Link>
                
                <Link to="/options" className=''>
                    <SettingsIcon />
                </Link>
                <Link to="/info" className=''>
                    <InfoIcon />
                </Link>
                <button className='cursor-pointer' type="button" onClick={() => setOpen(!open)}>
                    {open ? (
                        <CloseIcon />
                    ) : (
                        <ProfileIcon />
                    )}
                </button>
            </div>
            </header>
            <nav 
                className={
                    `fixed top-[60px] w-full h-[100vh] bg-custom-darker sm:max-w-[300px] z-[1000] text-lg sm:text-sm
                    ${open ? 'right-0' : 'right-[-100%]'}
                    transition-all ease-in-out duration-500 border-l border-custom-charcoal`
                }
            >
                <ul>
                    <li>
                        <Link to="/account/overview" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Account</Link>
                    </li>
                    <li>
                        <button onClick={handleLogout} className='block w-full px-5 py-4 border-b border-custom-charcoal text-left'>
                            {isLoading ? 'Logging out...' : 'Logout'}
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default Header;
